import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  AppState,
  GoogleMapsApiActions,
  NotificationSelectors,
} from '@app/store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ConnectOpaFooterComponent } from './connect-opa-footer/connect-opa-footer.component';
import { INotification } from './core/models';
import {
  FooterComponent,
  GovSiteLinkComponent,
  ToastComponent,
} from './shared/ui';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    ConnectOpaFooterComponent,
    FooterComponent,
    GovSiteLinkComponent,
    RouterModule,
    ToastComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public notifications$: Observable<INotification[]>;
  private store$ = inject(Store<AppState>);

  constructor() {
    this.notifications$ = this.store$.select(
      NotificationSelectors.selectNotifications,
    );
    this.store$.dispatch(GoogleMapsApiActions.loadGoogleMapsApi());
  }
}
